import { PARAMETER_CONFIGS, ParameterConfig } from '../constant';

export class MinMaxHelper {

    static initializeParameters(): ParameterConfig[] {
        return PARAMETER_CONFIGS.map(cfg => ({
            key: cfg.key,
            params: cfg.params,
            unit: cfg.unit,
            min: Number.MAX_VALUE,
            minDate: '',
            max: -Number.MAX_VALUE,
            maxDate: ''
        }));
    }

    static processBuckets(buckets: any[], parametersList: ParameterConfig[]) {
        buckets.forEach(element => {
            const timeStr = element.key_as_string.slice(11, 19);

            parametersList.forEach(param => {
                const val = element[param.key!]?.value;
                if (val !== undefined && val !== null) {
                    if (val < (param.min || Number.MAX_VALUE)) {
                        param.min = val;
                        param.minDate = timeStr;
                    }
                    if (val > (param.max || Number.MIN_VALUE)) {
                        param.max = val;
                        param.maxDate = timeStr;
                    }
                }
            });
        });
    }

    static sanitizeMinMaxValues(parametersList: ParameterConfig[]) {
        parametersList.forEach(p => {
            if (p.min === Number.MAX_VALUE) p.min = 0;
            if (p.max === Number.MIN_VALUE) p.max = 0;
        });
    }

    static resetValuesToZero(parametersList: ParameterConfig[]) {
        parametersList.forEach(p => { p.min = 0; p.max = 0; });
    }
}
